<template>
    <div class="block-editor ai-classification payload" v-if="clone">
        <div class="mode-selector">
            <strong>Sınıflandırma Modu:</strong>
            <div class="mode-buttons">
                <button
                    type="button"
                    :class="['mode-button', { active: (clone.mode || 'text') === 'text' }]"
                    @click="setMode('text')"
                >
                    <i class="material-icons">text_fields</i>
                    Text Mode
                </button>
                <button
                    type="button"
                    :class="['mode-button', { active: (clone.mode || 'text') === 'image' }]"
                    @click="setMode('image')"
                >
                    <i class="material-icons">image</i>
                    Image Mode
                </button>
            </div>
        </div>

        <strong>{{ $t("message.expressionClassified") }}: </strong>
        <div class="says">
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                placeholder="Ek talimatlar, özel koşullar veya sınıflandırmayı etkileyecek bilgiler (opsiyonel)"
                v-model="clone.message"
                :key="'tiptap-prompt' + renderKey"
            />
        </div>

        <div v-if="!isTextMode">
            <strong>{{ $t("chatbotv2.aiClassificationImageUrlLabel") }}: </strong>
            <div class="says">
                <TiptapEditor
                    :show-emoji="false"
                    :show-attributes="true"
                    placeholder="Image Url"
                    v-model="clone.imageUrl"
                    :key="'tiptap-image-url' + renderKey"
                />
            </div>
        </div>
        <strong>{{ $t("message.classification") }}:</strong>
        <div class="says" v-for="(tag, i) in clone.tags" :key="i">
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                :placeholder="$t('message.classification')"
                :value="tag"
                @input="changeTags(i, $event)"
            />
            <SupsisButton danger @click="removeTag(i)" small>
                <span class="material-icons">delete</span>
            </SupsisButton>
        </div>
        <a-divider />
        <SupsisButton primary @click="addTag"
            ><span class="material-icons">add</span> {{ $t("message.classification") }}</SupsisButton
        >
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import log2 from "../../../../../../utils/log2";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

const log = log2("AIClassification");
export default {
    name: "AIClassification",
    components: { TiptapEditor, SupsisButton },
    props: {
        value: {
            type: Object,
            default: () => ({
                message: "",
                imageUrl: "",
                tags: [],
                mode: "text",
            }),
        },
    },
    data() {
        const cloned = this.normalizeClone(_.cloneDeep(this.value));
        return {
            clone: cloned,
            renderKey: 0,
        };
    },
    computed: {
        isTextMode() {
            return (this.clone.mode || "text") === "text";
        },
    },
    watch: {
        clone: {
            handler(newValue) {
                this.$emit("input", newValue);
            },
            deep: true,
        },
    },
    methods: {
        normalizeClone(payload) {
            const normalized = payload || {};
            if (!normalized.mode) normalized.mode = "text";
            if (typeof normalized.imageUrl === "undefined") normalized.imageUrl = "";
            if (typeof normalized.message === "undefined") normalized.message = "";
            if (!Array.isArray(normalized.tags)) normalized.tags = [];
            return normalized;
        },
        changeTags(index, value) {
            this.clone = {
                message: this.clone.message,
                imageUrl: this.clone.imageUrl,
                mode: this.clone.mode,
                tags: this.clone.tags.map((tag, i) => {
                    if (index === i) tag = value;
                    return tag;
                }),
            };
        },
        addTag() {
            this.clone.tags.push(`Class ${this.clone.tags.length + 1}`);
            this.renderKey++;
        },
        removeTag(index) {
            this.clone.tags.splice(index, 1);
            this.renderKey++;
        },
        setMode(mode) {
            this.clone.mode = mode;
            this.handleModeChange();
        },
        handleModeChange() {
            const mode = this.clone.mode || "text";
            this.clone.mode = mode;
            if (mode === "text") {
                if (!this.clone.message && this.value && this.value.message) {
                    this.clone.message = this.value.message;
                }
                this.clone.imageUrl = "";
            } else {
                if (!this.clone.imageUrl && this.value && this.value.imageUrl) {
                    this.clone.imageUrl = this.value.imageUrl;
                }
            }
        },
    },
};
</script>

<style lang="scss">
.block-editor.ai-classification {
    padding: 30px 30px 90px;

    .mode-selector {
        margin-bottom: 20px;

        strong {
            display: block;
            margin-bottom: 12px;
            color: #333;
            font-size: 14px;
        }

        .mode-buttons {
            display: flex;
            gap: 12px;

            .mode-button {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 16px;
                border: 2px solid #e8e8e8;
                border-radius: 8px;
                background: #ffffff;
                color: #666;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.2s ease;
                outline: none;

                .material-icons {
                    font-size: 18px;
                }

                &:hover {
                    border-color: #1890ff;
                    color: #1890ff;
                    transform: translateY(-1px);
                    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
                }

                &.active {
                    border-color: #1890ff;
                    background: #1890ff;
                    color: white;
                    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);

                    &:hover {
                        background: #40a9ff;
                        border-color: #40a9ff;
                        transform: translateY(-1px);
                    }
                }
            }
        }
    }

    .says {
        display: flex;
        gap: 5px;
        align-items: center;
        flex-direction: row !important;

        .supsis-button {
            background: transparent !important;
            color: red !important;
            border: none !important;
        }
    }

    .ai-classification-header {
        align-items: center;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 16px;

        .material-icons {
            margin-right: 6px;
        }
    }

    .editable-editor-wrapper {
        border: 1px solid white;
        border-radius: 13px;
        //max-height: 50px;

        .editable-editor {
            //max-height: 50px;

            .ProseMirror {
                //max-height: 50px;
                overflow-y: auto;
            }
        }

        &.focused {
            border-color: #006cff;
        }

        &:hover {
            border-color: #006cff;
        }
    }
}
</style>
